<nav class="sn-breadcrumb" aria-label="Breadcrumb" *ngIf="crumbs?.length">
  <ol class="sn-breadcrumb__list sn-breadcrumb__list--full">
    <ng-container *ngFor="let crumb of head; trackBy: trackByLabel">
      <ng-container *ngTemplateOutlet="item; context: {$implicit: crumb}"></ng-container>
    </ng-container>
    <li *ngIf="folded" class="sn-breadcrumb__item sn-breadcrumb__more">
      <button type="button" class="sn-breadcrumb__more-button" [attr.aria-label]="'Show ' + hidden.length + ' more'"
              [title]="hiddenLabels" (click)="expanded = true">…</button>
    </li>
    <ng-container *ngFor="let crumb of tail; trackBy: trackByLabel">
      <ng-container *ngTemplateOutlet="item; context: {$implicit: crumb}"></ng-container>
    </ng-container>
  </ol>

  <!-- A phone: the way back to the parent, and the page's own name. -->
  <div class="sn-breadcrumb__compact">
    <a *ngIf="parent" class="sn-breadcrumb__back" [routerLink]="parent.path" [queryParams]="parent.queryParams"
       [attr.aria-label]="'Back to ' + parent.label">
      <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
    </a>
    <span class="sn-breadcrumb__current" aria-current="page">{{ current?.label }}</span>
  </div>

  <ng-template #item let-crumb>
    <li class="sn-breadcrumb__item">
      <a *ngIf="crumb.path && !crumb.current; else plain" class="sn-breadcrumb__link" [title]="crumb.label"
         [routerLink]="crumb.path" [queryParams]="crumb.queryParams">{{ crumb.label }}</a>
      <ng-template #plain>
        <span class="sn-breadcrumb__text" [class.sn-breadcrumb__text--current]="crumb.current" [title]="crumb.label"
              [attr.aria-current]="crumb.current ? 'page' : null">{{ crumb.label }}</span>
      </ng-template>
    </li>
  </ng-template>
</nav>
